export default __webpack_public_path__ + "svgs/medionLogo-f60b3875.svg";